module.exports = function (app, mod, tweet) {
  var notice = (tweet === null || tweet === void 0 ? void 0 : tweet.notice) || '';

  // Extract hypertext-y mentions!
  var text = app.browser.markupMentions((tweet === null || tweet === void 0 ? void 0 : tweet.text) || '');
  var identicon_src = app.keychain.returnIdenticon(tweet.tx.from[0].publicKey);
  var identicon_color = app.keychain.returnIdenticonColor(tweet.tx.from[0].publicKey);
  var curation_info = '';
  if (tweet.sources.length) {
    var source = tweet.sources[0];
    if (source !== null && source !== void 0 && source.type) {
      curation_info += " data-source-type=\"".concat(source.type, "\"");
    }
    if (source !== null && source !== void 0 && source.node) {
      curation_info += " data-source-node=\"".concat(source.node, "\"");
    }
  }
  curation_info += " data-curated=\"".concat(tweet.curated || 0, "\"");
  if (app.modules.moderateAddress(mod.publicKey) && tweet.curation_check && tweet.curated == 0) {
    curation_info += ' data-check="1"';
  } else {
    tweet.curation_check = false;
  }
  if (!text && !notice && tweet.retweet_tx) {
    notice = 'retweeted by ' + app.browser.returnAddressHTML(tweet.tx.from[0].publicKey);
  }
  var is_liked_css = mod.liked_tweets.includes(tweet.tx.signature) ? 'liked' : '';
  var is_retweeted_css = mod.retweeted_tweets.includes(tweet.tx.signature) ? 'retweeted' : '';
  var is_replied_css = mod.replied_tweets.includes(tweet.tx.signature) ? 'replied' : '';
  var comment_count = tweet.num_replies;
  if (tweet.rethread) {
    comment_count = comment_count + tweet.tree_size - 1;
  }
  var controls = "\n                <div class=\"tweet-tool tweet-tool-comment\" title=\"Reply/Comment\">\n                  <span class=\"tweet-tool-comment-count ".concat(is_replied_css, "\">").concat(tweet.num_replies, "</span>\n                  <i class=\"far fa-comment ").concat(is_replied_css, "\"></i>\n                </div>\n                <div class=\"tweet-tool tweet-tool-retweet\" title=\"Retweet/Quote-tweet\">\n                \t<span class=\"tweet-tool-retweet-count ").concat(is_retweeted_css, "\">").concat(tweet.num_retweets, "</span>\n                  <i class=\"fa fa-repeat ").concat(is_retweeted_css, "\"></i>\n                </div>\n                <div class=\"tweet-tool tweet-tool-like\" title=\"Like tweet\">\n\t\t  \t\t\t\t\t\t<span class=\"tweet-tool-like-count ").concat(is_liked_css, "\">").concat(tweet.num_likes, "</span>\n                  <div class=\"heart-bg\">\n                    <div class=\"heart-icon ").concat(is_liked_css, "\"></div>\n                  </div>\n\t\t\t\t\t\t\t\t</div>\n                <div class=\"tweet-tool tweet-tool-share\" title=\"Copy link to tweet\">\n                \t<i class=\"fa-solid fa-share-nodes\"></i>\n                </div>\n\t\t\t\t\t\t\t\t<div class=\"tweet-tool tweet-tool-more\" title=\"More options\">\n\t\t\t\t\t\t\t\t\t<i class=\"fa-solid fa-ellipsis\"></i>\n\t\t\t\t\t\t\t\t</div>\n\t");
  var html = "\n\n\t  <div class=\"tweet tweet-".concat(tweet.tx.signature, " ").concat(tweet.reply_class, "\" data-id=\"").concat(tweet.tx.signature, "\" ").concat(curation_info, ">\n      <img class=\"tweet-avatar saito-add-user-menu\" src=\"").concat(identicon_src, "\" data-id=\"").concat(tweet.tx.from[0].publicKey, "\" />\n      <div class=\"tweet-body\">\n\t      <div class=\"tweet-context\">").concat(notice, "</div>\n\t      <div class=\"tweet-curation\">").concat(curation_info.replace(/data-/g, '<br>').substring(5), "</div>\n        <div class=\"tweet-header\"></div>\n        <div class=\"tweet-text\">").concat(app.browser.sanitize(text, true), "</div>\n\t      <div class=\"tweet-image\"></div>\n\t      <div class=\"tweet-retweet\"></div>\n\t      <div class=\"tweet-link-preview\"></div>\n\n\t");
  if (tweet.youtube_id != null && tweet.youtube_id != 'null') {
    html += "<iframe class=\"youtube-embed\" src=\"https://www.youtube.com/embed/".concat(tweet.youtube_id, "\"></iframe>");
  }
  if (tweet !== null && tweet !== void 0 && tweet.show_controls) {
    html += "<div class=\"tweet-controls saito-menu-select-subtle\">".concat(controls, "</div>");
  }
  if (tweet.curation_check) {
    controls = "\n\t\t\t\t\t\t\t\t<div class=\"tweet-tool saito-button-secondary\" id=\"hide-spam\" title=\"mark spam\"><i class=\"fa-solid fa-xmark\"></i></div>\n\t\t\t\t\t\t\t\t<div class=\"tweet-tool saito-button-secondary\" id=\"approve-tweet\" title=\"approve tweet\"><i class=\"fa-solid fa-check\"></i></div>\n\t\t";
    html += "<div class=\"tweet-curation-controls\">".concat(controls, "</div>");
  }
  html += "\n      </div>\n    </div>\n\t";
  return html;

  /****
  if (tweet.youtube_id != null && tweet.youtube_id != 'null') {
  	html += `<iframe class="youtube-embed" src="https://www.youtube.com/embed/${tweet.youtube_id}"></iframe>`;
  } else {
  	html += `<div class="tweet-preview tweet-preview-${tweet.tx.signature}"></div>`;
  }
  	if (tweet?.show_controls) {
  	html += controls;
  }
  	html += `</div>
           </div>
         </div>
   `;
  ****/
};